module.exports = __webpack_public_path__ + "img/Home-icon.f054438e.svg";